import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('User', () => {
  const user = ref({
    id: null,
    known_user_signed_in: false
  })

  const id = computed(() => user.value.id)
  const isKnownUser = computed(() => user.value.known_user_signed_in === true)

  function setUser(newUser) {
    user.value = newUser
  }

  function refreshLogin(json) {
    if (json.data?.user.known_user_signed_in) {
      user.value = { ...user.value, id: json.data.user.id }
    }
  }

  function $reset() {
    user.value = {
      id: null,
      known_user_signed_in: false
    }
  }

  return { user, id, isKnownUser, setUser, refreshLogin, $reset }
})
